export default {
  // Specify the element to use as a container, string (query) or HTMLElement
  // With the empty value, nothing will be rendered
  appendTo: '',

  // Append blocks to canvas on click
  appendOnClick: 0,

  blocks: [
    //layout
    {
      id: 'onecolumn',
      label: '<b>one Column<b>',
      icon: 'onecolumnblock.svg',
      content: `
      <div  class="dhq_row" data-gjs-droppable=".dhq_cell" data-gjs-resizable='{"tl":0,"tc":0,"tr":0,"cl":0,"cr":0,"bl":0,"br":0,"minDim":1}' data-gjs-name="dhq_row">
        <div  class="dhq_cell" data-gjs-draggable=".dhq_row" data-gjs-resizable='{"tl":0,"tc":0,"tr":0,"cl":0,"cr":1,"bl":0,"br":0,"minDim":1,"bc":0,"currentUnit":1,"step":0.2,"keyWidth":"flex-basis"}' data-gjs-name="dhq_cell" data-gjs-unstylable='["width"]' data-gjs-stylable-require='["flex-basis"]'></div>
      </div>
      <style>          
        .dhq_row {
          display: flex;
          justify-content: flex-start;
          align-items: stretch;
          flex-wrap: nowrap;
          padding: 10px;
        }
        @media (max-width: 768px) {
          .dhq_row {
            flex-wrap: wrap;
          }
        }
              
        .dhq_cell {
          min-height: 75px;
          flex-grow: 1;
          flex-basis: 100%;
        }
      </style>`,
      category: 'Layout',
      attributes: {
        title: 'Insert Div Block'
      }
    },
    {
      id: 'twocolumn',
      label: '<b>Two Column<b>',
      icon: 'twocolumnblock.svg',
      content: `
      <div  class="dhq_row" data-gjs-droppable=".dhq_cell" data-gjs-resizable='{"tl":0,"tc":0,"tr":0,"cl":0,"cr":0,"bl":0,"br":0,"minDim":1}' data-gjs-name="dhq_row">
        <div  class="dhq_cell" data-gjs-draggable=".dhq_row" data-gjs-resizable='{"tl":0,"tc":0,"tr":0,"cl":0,"cr":1,"bl":0,"br":0,"minDim":1,"bc":0,"currentUnit":1,"step":0.2,"keyWidth":"flex-basis"}' data-gjs-name="dhq_cell" data-gjs-unstylable='["width"]' data-gjs-stylable-require='["flex-basis"]'></div>
        <div  class="dhq_cell" data-gjs-draggable=".dhq_row" data-gjs-resizable='{"tl":0,"tc":0,"tr":0,"cl":0,"cr":1,"bl":0,"br":0,"minDim":1,"bc":0,"currentUnit":1,"step":0.2,"keyWidth":"flex-basis"}' data-gjs-name="dhq_cell" data-gjs-unstylable='["width"]' data-gjs-stylable-require='["flex-basis"]'></div>
      </div>
      <style>          
        .dhq_row {
          display: flex;
          justify-content: flex-start;
          align-items: stretch;
          flex-wrap: nowrap;
          padding: 10px;
        }
        @media (max-width: 768px) {
          .dhq_row {
            flex-wrap: wrap;
          }
        }
              
        .dhq_cell {
          min-height: 75px;
          flex-grow: 1;
          flex-basis: 100%;
        }
      </style>`,
      category: 'Layout',
      attributes: {
        title: 'Insert Div Block'
      }
    },
    {
      id: 'threecolumn',
      label: '<b>Three Column<b>',
      icon: 'threecolumnblock.svg',
      content: `
      <div class="dhq_row" data-gjs-droppable=".dhq_cell"
          data-gjs-resizable='{"tl":0,"tc":0,"tr":0,"cl":0,"cr":0,"bl":0,"br":0,"minDim":1}' data-gjs-name="dhq_row">
          <div class="dhq_cell" data-gjs-draggable=".dhq_row"
              data-gjs-resizable='{"tl":0,"tc":0,"tr":0,"cl":0,"cr":1,"bl":0,"br":0,"minDim":1,"bc":0,"currentUnit":1,"step":0.2,"keyWidth":"flex-basis"}'
              data-gjs-name="dhq_cell" data-gjs-unstylable='["width"]' data-gjs-stylable-require='["flex-basis"]'></div>
          <div class="dhq_cell" data-gjs-draggable=".dhq_row"
              data-gjs-resizable='{"tl":0,"tc":0,"tr":0,"cl":0,"cr":1,"bl":0,"br":0,"minDim":1,"bc":0,"currentUnit":1,"step":0.2,"keyWidth":"flex-basis"}'
              data-gjs-name="dhq_cell" data-gjs-unstylable='["width"]' data-gjs-stylable-require='["flex-basis"]'></div>
          <div class="dhq_cell" data-gjs-draggable=".dhq_row"
              data-gjs-resizable='{"tl":0,"tc":0,"tr":0,"cl":0,"cr":1,"bl":0,"br":0,"minDim":1,"bc":0,"currentUnit":1,"step":0.2,"keyWidth":"flex-basis"}'
              data-gjs-name="dhq_cell" data-gjs-unstylable='["width"]' data-gjs-stylable-require='["flex-basis"]'></div>
      </div>
      <style>
          .dhq_row {
              display: flex;
              justify-content: flex-start;
              align-items: stretch;
              flex-wrap: nowrap;
              padding: 10px;
          }

          @media (max-width: 768px) {
              .dhq_row {
                  flex-wrap: wrap;
              }
          }

          .dhq_cell {
              min-height: 75px;
              flex-grow: 1;
              flex-basis: 100%;
          }
      </style>`,
      category: 'Layout',
      attributes: {
        title: 'Insert Div Block'
      }
    },
    {
      id: 'grid',
      label: '<b>Grid</b>',
      icon: 'gridblock.svg',
      content: `<div  class="dhq_grid" data-gjs-droppable=".dhq_grid_item" data-gjs-resizable='{"tl":0,"tc":0,"tr":0,"cl":0,"cr":0,"bl":0,"br":0,"minDim":1}' data-gjs-name="Grid">
        <div  class="dhq_grid_item" data-gjs-draggable=".dhq_grid" data-gjs-resizable='{"tl":0,"tc":0,"tr":0,"cl":0,"cr":1,"bl":0,"br":0,"minDim":1,"bc":0,"currentUnit":1,"step":0.2,"keyWidth":"flex-basis"}' data-gjs-name="Grid item" data-gjs-unstylable='["width"]' data-gjs-stylable-require='["flex-basis"]'></div>
        <div  class="dhq_grid_item" data-gjs-draggable=".dhq_grid" data-gjs-resizable='{"tl":0,"tc":0,"tr":0,"cl":0,"cr":1,"bl":0,"br":0,"minDim":1,"bc":0,"currentUnit":1,"step":0.2,"keyWidth":"flex-basis"}' data-gjs-name="Grid item" data-gjs-unstylable='["width"]' data-gjs-stylable-require='["flex-basis"]'></div>
        <div  class="dhq_grid_item" data-gjs-draggable=".dhq_grid" data-gjs-resizable='{"tl":0,"tc":0,"tr":0,"cl":0,"cr":1,"bl":0,"br":0,"minDim":1,"bc":0,"currentUnit":1,"step":0.2,"keyWidth":"flex-basis"}' data-gjs-name="Grid item" data-gjs-unstylable='["width"]' data-gjs-stylable-require='["flex-basis"]'></div>
        <div  class="dhq_grid_item" data-gjs-draggable=".dhq_grid" data-gjs-resizable='{"tl":0,"tc":0,"tr":0,"cl":0,"cr":1,"bl":0,"br":0,"minDim":1,"bc":0,"currentUnit":1,"step":0.2,"keyWidth":"flex-basis"}' data-gjs-name="Grid item" data-gjs-unstylable='["width"]' data-gjs-stylable-require='["flex-basis"]'></div>
      </div>
      <style>          
        .dhq_grid {
          display: flex;
          justify-content: flex-start;
          align-items: stretch;
          flex-wrap: wrap;
          padding: 10px;
        }
        @media (max-width: 768px) {
          .dhq_grid_item {
            flex-basis:100%;
          }
        }
              
        .dhq_grid_item {
          min-height: 75px;
          flex-grow: 1;
          flex-basis: 50%;
        }
      </style>`,
      category: 'Layout'
    },
    {
      id: 'container',
      label: '<b>Container<b>',
      icon: 'container.svg',
      content: {
        type: 'default',
        name: 'Block',
        style: {
          padding: '20px'
        }
      },
      category: 'Layout',
      attributes: {
        title: 'Insert Div Block'
      }
    },

    // basic
    {
      id: 'h-navbar',
      label: '<b>Navbar</b>',
      icon: 'navblock.svg',
      content: ` <div class="dhq_navbar" data-gjs-droppable="false" data-gjs-name="Navbar" data-gjs="navbar">
          <div class="dhq_navbar-container" data-gjs-droppable="false" data-gjs-draggable="false"
            data-gjs-removable="false" data-gjs-copyable="false" data-gjs-highlightable="false"
            data-gjs-name="Navbar Container">

            <div class="dhq_navbar-brand" data-gjs-droppable="true"></div>

            <div class="dhq_navbar-burger" data-gjs-type="burger-menu">
              <div class="dhq_navbar-burger-line" data-gjs-name="Burger Line" data-gjs-droppable="false" data-gjs-draggable="false"></div>
              <div class="dhq_navbar-burger-line" data-gjs-name="Burger Line" data-gjs-droppable="false" data-gjs-draggable="false"></div>
              <div class="dhq_navbar-burger-line" data-gjs-name="Burger Line" data-gjs-droppable="false" data-gjs-draggable="false"></div>
            </div>

            <div class="dhq_navbar-items-c" data-gjs="navbar-items">
              <nav class="dhq_navbar-menu" data-gjs="navbar-menu" data-gjs-name="Navbar Menu">
                <div class="dhq_navbar-menuitem"><div class="dhq_navbar-menu-link" data-gjs-name="Menu link" data-gjs-draggable="[data-gjs=navbar-menu]">Home</div></div>
                <div class="dhq_navbar-menuitem"><div class="dhq_navbar-menu-link" data-gjs-name="Menu link" data-gjs-draggable="[data-gjs=navbar-menu]">About</div></div>
                <div class="dhq_navbar-menuitem"><div class="dhq_navbar-menu-link" data-gjs-name="Menu link" data-gjs-draggable="[data-gjs=navbar-menu]">Contact</div>
              </nav>
            </div>
          </div>
        </div>
        
  <style>
    .dhq_navbar-items-c {
      display: inline-block;
      float: right;
    }

    .dhq_navbar {
      background-color: #ffffff;
      color: #000000;
      min-height: 50px;
      width: 100%;
    }

    .dhq_navbar-container {
      max-width: 950px;
      margin: 0 auto;
      width: 95%;
    }
    
    .dhq_navbar-container::after {
      content: "";
      clear: both;
      display: block;
    }

    .dhq_navbar-brand {
      vertical-align: top;
      display: inline-block;
      padding: 5px;
      height:50px;
      min-height: 50px;
      min-width: 50px;
      color: inherit;
      text-decoration: none;
    }

    .dhq_navbar-menu {
      padding: 5px 0;
      display: flex;
      float: right;
      margin: 0;
      height:50px;
    }

    .dhq_navbar-menuitem{
      display:flex;
    }

    .dhq_navbar-menu-link {
      margin: 0;
      color: inherit;
      text-decoration: none;
      display: block;
      padding: 10px 15px;
    }

    .dhq_navbar-burger {
      margin: 7px 0;
      width: 45px;
      padding: 5px 10px;
      display: none;
      float: right;
      cursor: pointer;
    }

    .dhq_navbar-burger-line {
      padding: 1px;
      background-color: black;
      margin: 5px 0;
    }

    @media (max-width: 768px) {
      .dhq_navbar-burger {
        display: block;
      }

      .dhq_navbar-items-c {
        display: none;
        width: 100%;
      }

      .dhq_navbar-menu {
        display:block;
        width: 100%;
        height:auto;
      }

      .dhq_navbar-menu-link {
        display: block;
      }
    }
  </style>`,
      category: 'Basic',
      attributes: {
        title: 'Insert Navbar'
      }
    },
    {
      id: 'image',
      label: '<b>Image<b>',
      icon: 'imageblock.svg',
      content: {
        type: 'image',
        style: {
          width: '200px',
          height: '200px',
          padding: '10px'
        }
      },
      category: 'Basic',
      attributes: {
        title: 'Insert Image'
      }
    },
    // {
    //   id: 'video',
    //   label: '<b>Video<b>',
    //   icon: '',
    //   content: {
    //     type: 'video'
    //   },
    //   category: 'Basic',
    //   attributes: {
    //     title: 'Insert Image'
    //   }
    // },
    {
      id: 'text',
      label: '<b>Text<b>',
      icon: 'textblock.svg',
      content: {
        type: 'text',
        content: 'Double click here to edit',
        resizable: true
      },
      category: 'Basic',
      attributes: {
        title: 'Insert Text'
      }
    },
    {
      id: 'label',
      label: '<b>Label<b>',
      icon: 'labelblock.svg',
      content: {
        type: 'label',
        content: 'Double Click To Edit'
      },
      category: 'Basic',
      attributes: {
        title: 'Insert Text'
      }
    },
    {
      id: 'horizontal_divider',
      label: '<b>Hr<b>',
      icon: 'hr.svg',
      content: `
      <div class="dhq_hr" data-gjs-droppable = "false" data-gjs-stylable='["width","border","border-width","border-color","border-style"]' data-gjs-name="dhq_hr" data-gjs-resizable='{"tl":0,"tc":0,"tr":0,"cl":1,"cr":1,"bl":0,"br":0,"minDim":1,"bc":0,"currentUnit":1,"step":1}'></div>
        <style>
          .dhq_hr{
            width: 100%;
            height: 0px;
            border: 1px solid black;
          }
        </style>
      `,
      category: 'Basic'
    },
    {
      id: 'vertical_divider',
      label: '<b>Vr</b>',
      icon: 'vr.svg',
      content: `
      <div class="dhq_vr" data-gjs-droppable = "false"  data-gjs-stylable='["height","border","border-width","border-color","border-style"]' data-gjs-name="dhq_vr" data-gjs-resizable='{"tl":0,"tc":1,"tr":0,"cl":0,"cr":0,"bl":0,"br":0,"minDim":1,"bc":1,"currentUnit":1,"step":1}'></div>
        <style>
          .dhq_vr{
            width:0px;
            height: 100%;
            border: 1px solid black;
          }
        </style>
      `,
      category: 'Basic'
    },
    {
      id: 'button',
      label: '<b>Button</b>',
      icon: 'buttonblock.svg',
      content: `<div class="dhq_button" data-gjs-name="Button" actionable eventname="Button Clicked">
        <div>Click Me</div>
      </div>
      <style>
        .dhq_button{
          height:40px;
          width:100%;
          display:flex;
          justify-content:center;
          align-items:center;
          background-color:#26bc6a;
          color:#ffffff;
          border-radius:5px;
        }
        .dhq_button:active{
          opacity:0.8;
        }
      </style>
      `,
      category: 'Basic'
    },
    {
      id: 'badge',
      label: '<b>Badge</b>',
      icon: 'badgeblock.svg',
      content: `<div class="dhq_badge" data-gjs-name="Badge">Badge</div>
      <style>
        .dhq_badge{
          width:fit-content;
          padding:5px;
          background-color:#26bc6a;
          color:white;
        }
      </style>
      `,
      category: 'Basic'
    }

    //input
    // {
    //   id: 'input',
    //   label: '<b>Input<b>',
    //   icon: 'inputblock.svg',
    //   content: {
    //     type: 'input'
    //   },
    //   category: 'Form Element'
    // },
  ]
};
